import styled from "@emotion/styled";

// @ts-ignore
export const SelectReplacementReasonWrapper = styled.div(({ theme }) => ({
	display: "flex",
	width: "100%",
	padding: "16px",
	boxSizing: "border-box",
	gap: "24px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start"
	}
}));

export const SelectReplacementReasonPartInfo = styled.div(({ theme }) => ({
	flex: 1,
	"> div": {
		display: "grid",
		gridTemplateColumns: "12fr 4fr",
		width: "100%",
		alignItems: "center"
	},
	[theme.breakpoints.down("md")]: {
		width: "100%",
		"> div": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%"
		}
	}
}));

export const SelectReplacementReasonPartInfoSku = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	color: theme.project.colors.fontColors.main,
	"span:first-of-type": theme.project.typography.subtitle.subtitle1,
	"span:last-of-type": theme.project.typography.body.body2
}));

export const SelectReplacementReasonPartInfoQty = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	color: theme.project.colors.fontColors.main,
	"span:first-of-type": theme.project.typography.subtitle.subtitle2,
	"span:not(:first-of-type)": theme.project.typography.body.body2
}));

export const SelectReplacementReasonReview = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	flex: 1
});

export const SelectReplacementReasonDropdowns = styled.div({
	flex: 1
});
